import React from 'react';
import { Grid, Typography, Button } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
// styles
import useStyles from './styles';

import google from '../../images/google.svg';

// context
import { useUserDispatch, loginUser } from '../../context/UserContext';

import useFirebase from '../../hooks/useFirebase';

function Login(props) {
  var classes = useStyles();

  const firebase = useFirebase();

  // global
  var userDispatch = useUserDispatch();

  return (
    <Grid container className={classes.container}>
      <div className={classes.formContainer}>
        <div className={classes.form}>
          <React.Fragment>
            <Typography variant="h1" className={classes.greeting}>
              Good Morning, User
            </Typography>
            <Button
              size="large"
              className={classes.googleButton}
              onClick={() => loginUser(firebase, userDispatch, props.history)}
            >
              <img src={google} alt="google" className={classes.googleIcon} />
              &nbsp;Sign in with Google
            </Button>
          </React.Fragment>
        </div>
      </div>
    </Grid>
  );
}

export default withRouter(Login);
